function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Z8NiYD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M115.94,61a3,3,0,0,1-3.14,1.72c-1.51,0-3,0-4.53,0-2,0-2.65-.61-3-2.5C103.85,52,96.16,48.09,88.9,49.82c-5.37,1.28-8.6,4.68-9.75,10.07-.5,2.32-1.06,2.77-3.47,2.78H48.51c-2.55,0-3.32-.76-3.32-3.3v-56C45.19.73,45.9,0,48.46,0q32.14,0,64.3,0a3.14,3.14,0,0,1,3.18,1.63Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.58,37.66q0,10.86,0,21.73c0,2.55-.73,3.27-3.31,3.28h-.79c-2.08,0-2.72-.72-3.2-2.75a15.51,15.51,0,0,0-1.6-4.29c-2.6-4.4-6.71-6.24-11.68-6.2A12.68,12.68,0,0,0,7.39,59.27c-.08.33-.12.66-.18,1a2.51,2.51,0,0,1-2.67,2.38,14.69,14.69,0,0,1-2.48-.08A2.16,2.16,0,0,1,0,60.28c0-7.54,0-15.09,0-22.64a3.2,3.2,0,0,1,.8-1.8Q9.95,24.88,19.12,14a3.11,3.11,0,0,1,2.55-1.21c5.4,0,10.8,0,16.19,0,1.88,0,2.72.92,2.72,2.94Q40.6,26.67,40.58,37.66Zm-17-4.07h9.5c1.92,0,2.78-.8,2.8-2.72q.06-5.37,0-10.75c0-1.86-.89-2.65-2.75-2.66-3,0-6,0-9,0a3.42,3.42,0,0,0-2.93,1.36q-4.46,5.41-9,10.77a2.42,2.42,0,0,0-.51,2.71,2.29,2.29,0,0,0,2.4,1.32C17.28,33.57,20.44,33.59,23.61,33.59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.25,73.43a9.85,9.85,0,1,1,9.88-9.8A9.87,9.87,0,0,1,20.25,73.43Zm0-7a2.83,2.83,0,0,0,2.89-2.81,2.89,2.89,0,0,0-2.83-2.89,3,3,0,0,0-2.86,2.77A2.91,2.91,0,0,0,20.23,66.43Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.17,73.43a9.84,9.84,0,1,1,9.88-9.8A9.83,9.83,0,0,1,92.17,73.43Zm0-7a2.92,2.92,0,0,0,2.88-2.85,3,3,0,0,0-2.93-2.84,3,3,0,0,0-2.81,2.83A2.88,2.88,0,0,0,92.18,66.42Z"
}))));
function SvgIconShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.94 73.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShip);
export default __webpack_public_path__ + "static/media/icon-ship.d6193ff8d1f47f4b22f8b2f3451c5d07.svg";
export { ForwardRef as ReactComponent };